import { API_CONFIG } from '@/config/api'
import { baseService } from './baseService'

export interface AdminTotals {
  accounts_total: number
  researchers_total: number
  respondent_accounts_total: number
  studies_total: number
  studies_active: number
  studies_archived: number
  respondents_total: number
  respondents_completed: number
  recordings_total: number
  analysis_minutes_total: number
}

export interface AdminAccountRow {
  id: number
  email: string
  name: string
  plan: 'trial' | 'full'
  has_active_access: boolean
  date_joined: string
  studies_total: number
  studies_active: number
  studies_archived: number
  respondents_total: number
  respondents_completed: number
  recordings_total: number
  analysis_minutes: number
}

export interface AdminStudyRow {
  id: number
  name: string
  owner_email: string | null
  is_active: boolean
  status: 'draft' | 'active'
  respondents: number
  recordings: number
  analysis_minutes: number
  created_at: string
}

export interface AdminSignupPoint {
  date: string | null
  count: number
}

export interface AdminAnalysisPoint {
  job_id: number
  /** Length of the analyzed video, seconds. */
  video_seconds: number
  /** Wall-clock time the analysis pipeline ran, seconds. */
  analysis_seconds: number
}

export interface AdminAnalysisTimeStats {
  count: number
  shown: number
  truncated: boolean
  avg_seconds: number
  median_seconds: number
  max_seconds: number
  /** Seconds of processing per second of video. */
  avg_ratio: number
}

export interface AdminMetrics {
  totals: AdminTotals
  accounts: AdminAccountRow[]
  studies: AdminStudyRow[]
  signups_by_day: AdminSignupPoint[]
  analysis_points: AdminAnalysisPoint[]
  analysis_time_stats: AdminAnalysisTimeStats
}

export class AdminService {
  async getMetrics(): Promise<AdminMetrics> {
    const response = await baseService.get<AdminMetrics>(API_CONFIG.ENDPOINTS.ADMIN.METRICS)
    return response.data
  }
}

export const adminService = new AdminService()
